import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/base.css'
import './assets/main.css'

// Initialize the application with router
createApp(App).use(router).mount('#app')